import {Dispatch, SetStateAction, useContext, useEffect, useMemo, useRef, useState} from 'react';

import classNames from 'classnames';

import styles from "./SearchPage.module.scss"
import FontAwesome from "../../components/utilities/FontAwesome";
import {ExecutionEnvironment} from "../../stores/InterfaceStore";
import {StoreContext} from "../../stores/StoreContext";

const SearchBox: React.FC<{
    searchTerm: string,
    isValidating: boolean,
    inputValue: string,
    setInputValue: Dispatch<SetStateAction<string>>,
    handleSubmit: () => void,
}> = (props) => {
    const {organizationStore, gridStore} = useContext(StoreContext);
    const searchRef = useRef(null);
    const submitRef = useRef<HTMLButtonElement | null>(null);

    const [listening, setListening] = useState(false);

    const recognition = useMemo(() => {
        let r;
        //@ts-ignore
        if (ExecutionEnvironment.canUseDOM && (window.SpeechRecognition || window.webkitSpeechRecognition)) {
            //@ts-ignore
            const speechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            if (speechRecognition && typeof speechRecognition !== "undefined") {
                r = new speechRecognition();
                r.interimResults = true;
                r.maxAlternatives = 1;
                // r.lang = i18nStore.currentOrgSupportedLocale;
            }
        }
        return r;
    }, []);

    function handleClick(e) {
        e.preventDefault();
        if (listening && recognition) {
            recognition.abort();
            setListening(false);
        } else if (recognition) {
            recognition.start();
            setListening(true);
        }
    }

    function handleMouseDown(e) {
        // this is important to prevent focus from being shifted from the input, which then closes the search bar
        e.preventDefault();
    }

    function handleChange(e) {
        props.setInputValue(e.target.value);
    }

    useEffect(() => {
        if (recognition) {
            recognition.onresult = function (event) {
                const text = event.results[0][0].transcript;
                props.setInputValue(text);

                if (event.results[0].isFinal) {
                    setListening(false);
                    submitRef.current?.click();
                }
            };
            recognition.onerror = function (event) {
                setListening(false);
                let message: string | null = null;
                switch (event.error) {
                    case "network":
                        message = "There was a problem connecting to the network, please check your connection or browser settings to enable speech to text.";
                        break;
                    case "aborted":
                        break;
                    default:
                        message = "An error occurred! Please enable microphone access and try again!";
                        break;
                }
                if (message) {
                    alert(message);
                }
            }
        }
    }, []);

    const searchClassName = classNames({
        [styles.search]: true,
    })

    return <div className={styles.searchForm}>
        <input type="hidden"
               name="orgId"
               value={organizationStore.organization.id}/>
        <div className={searchClassName}>
            <input ref={searchRef}
                   id="sb-search-input-large"
                   name="q"
                   type="text"
                   aria-label="Search this site"
                   placeholder="Search"
                   value={props.inputValue}
                   onChange={handleChange}
                   autoComplete="off"
                   title="Search"
                   onKeyDown={(e) => {
                       if (e.key === 'Enter') {
                           e.preventDefault();
                           props.handleSubmit();
                       }
                   }}
            />
            {props.isValidating && <FontAwesome prefix={'fas'} name={'fa-spinner'} spin/>}
            <button type="submit"
                    ref={submitRef}
                    className={styles.eyeglass}
                    title="Submit search"
                    aria-label="Submit search"
                    onClick={props.handleSubmit}
            >
                <FontAwesome name={'fa-search'} prefix={'fas'} size={'lg'} className={styles.darkIcon}
                             aria-role={'presentation'} aria-hidden={true}/>
            </button>
            {recognition && <button title={"Search by voice"}
                                    aria-label={"Search by voice"}
                                    onClick={handleClick}
                                    onMouseDown={handleMouseDown}
                                    className={styles.speech}
            >
                <FontAwesome name={`${listening ? "fa-volume-down" : "fa-microphone"}`} prefix={'fas'}
                             size={'lg'} className={styles.darkIcon} aria-role={'presentation'}
                             aria-hidden={true}/>
            </button>}
        </div>
    </div>
}
export default SearchBox;
